import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { ConsultationTypeModalComponent } from './consultation-type-modal.component';



@NgModule({
  declarations: [ConsultationTypeModalComponent],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, PipesModule,
  ],
  exports: [ConsultationTypeModalComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
})
export class ConsultationTypeModalModule { }
